import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SearchService } from '@app/search/services/search.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-search-provider-no-results',
  templateUrl: './search-provider-no-results.component.html',
  styleUrls: ['./search-provider-no-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchProviderNoResultsComponent {
  @Input() public providerName: string;

  constructor(
    private searchService: SearchService,
    private translateService: TranslateService
  ) {}

  public get emptyImageURL(): string {
    return this.searchService.getEmptyImageUrl();
  }

  public get i18n(): { [key: string]: string } {
    return this.translateService.instant(
      [
        'Core_Empty_Image_Alt',
        'LearningSearch_Hmm',
        'LearningSearch_ProviderNotPartOfCatalog',
        'LearningSearch_ProviderNoResultsFoundAdvice',
      ],
      // params only apply to 'LearningSearch_ProviderNotPartOfCatalog'
      { providerName: this.providerName }
    );
  }
}
